<template>
  <div>
    <HomeTemplate :player_id="player_id" :players="players" @select-player="playerId => selectPlayer(playerId)"
                  @go-to-kill-list="goToKillList()" @go-to-my-platforms="goToMyPlatforms()"
                  @go-to-my-games="goToMyGames()" @go-to-my-recommendations="goToMyRecommendations()"
                  @go-to-history="goToHistory()"></HomeTemplate>
  </div>
</template>

<script>
  import axios from 'axios';
  import api from '@/api';
  import HomeTemplate from '../components/templates/HomeTemplate';

  export default {
    components: { HomeTemplate },
    data() {
      return {
        player_id: null,
        players: null,
      };
    },
    created() {
      this.player_id = this.$store.state.playerId;
    },
    mounted() {
      if (this.$route.query.player_id && this.$route.query.token) {
        this.$store.commit('setPlayerId', this.$route.query.player_id);
        this.$store.commit('setToken', this.$route.query.token);
        this.$store.dispatch('fetchMe');
      }
      axios.get(`${api.endpoint}/players`).then(response => (this.players = response.data));
    },
    methods: {
      selectPlayer(playerId) {
        this.player_id = playerId;
        this.$store.dispatch('setPlayerId', playerId);
      },
      goToKillList() {
        this.$router.push({ name: 'kill-list' });
      },
      goToMyPlatforms() {
        this.$router.push({ name: 'my-platforms', params: { id: this.player_id } });
      },
      goToMyGames() {
        this.$router.push({ name: 'my-games', params: { id: this.player_id } });
      },
      goToMyRecommendations() {
        this.$router.push({ name: 'my-recommendations', params: { id: this.player_id } });
      },
      goToHistory() {
        this.$router.push({ name: 'history' });
      },
    },
  };
</script>
